import { useNavigate } from "react-router"
import { ContractTypeFormValues, getContractTypeFormSchema } from "./contractTypeForm.utils"
import { zodResolver } from "@hookform/resolvers/zod"
import { useEffect } from "react"
import { useForm } from "react-hook-form"
import { CustomerType, Product } from "../../acquisitionForm/form/useAcquisitionFormSchema"
import { useAcquisitionFormSearchParams } from "../../acquisitionForm/useAcquisitionFormSearchParams"
import { useAcquisitionProgress } from "../AcquisitionProgressContext"

export function useContractTypeFormController(customerType: CustomerType) {
  const navigate = useNavigate()
  const progress = useAcquisitionProgress()

  const { product: productSearchParam, setSearchParam } = useAcquisitionFormSearchParams()

  const form = useForm<ContractTypeFormValues>({
    resolver: zodResolver(getContractTypeFormSchema(customerType)),
    defaultValues: progress.contractInfo
      ? {
          ...progress.contractInfo,
          product: productSearchParam ?? progress.contractInfo.product,
        }
      : {
          measurementTypeConsent: false,
          productionDataTariff: false,
        },
  })

  const { register, watch, setValue, handleSubmit } = form

  useEffect(() => {
    // https://react-hook-form.com/advanced-usage/#ControlledmixedwithUncontrolledComponents
    register("product")
  }, [register])

  function handleProductChange(product: Product) {
    setSearchParam("product", product)
    setValue("product", product)
  }

  function handleProductionDataTariffChange(value: boolean) {
    setValue("productionDataTariff", value)
  }

  function onSubmit(formData: ContractTypeFormValues) {
    progress.updateContractInfo?.(formData)
    navigate(`..${progress.nextStepUrl}`)
  }

  function handleReturn() {
    navigate(`..${progress.previousStepUrl}`)
  }

  const [product, productionDataTariff] = watch(["product", "productionDataTariff"])

  return {
    handleSubmit: handleSubmit(onSubmit),
    product,
    productionDataTariff,
    handleProductChange,
    handleProductionDataTariffChange,
    handleReturn,
    form,
    progress,
  }
}
